import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Provincia } from '../models/provincia';

@Injectable()
export class ProvinciaService {
    public url: string;
    public controller: string;
    constructor(
        private _http: HttpClient
    ) {
        this.url = environment.urlApi;
        this.controller = 'provincia/'
    }

    get(): Observable<any> {
        const json = this._http.get(this.url + this.controller);
        return json;
    }
    getByCountryId(countryId, active): Observable<any> {
        const json = this._http.get(this.url + this.controller + 'getdepartmentbycountryidincludeinactives/' + countryId + '/' + active);
        return json;
    }
    getById(id) {
        const json = this._http.get(this.url + this.controller + id);
        return json;
    }
    getByName(name): Observable<any> {
        const json = this._http.get(this.url + this.controller + 'getdepartmentbyname/' + name);
        return json;
    }
    create(entity: Provincia): Observable<any> {
        let json = JSON.stringify(entity);
        let params = json;
        let headers = new HttpHeaders().set('content-Type', 'application/json');
        return this._http.post(this.url + this.controller, params, {headers: headers});
     }
    update(id,entity: Provincia) {
        let json = JSON.stringify(entity);
        let params = json;
        let headers = new HttpHeaders().set('content-Type', 'application/json');
        return this._http.put(this.url + this.controller + id, params, {headers: headers});
     }
    delete() { }
    
}